import options from './component';


export default {
    selector: "dtEmulatorNetworkStatus",
    options
}